import { Box, SnackbarContent } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledErrorContainer = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 2,
}));
export const SnackbarContentContainer = styled(SnackbarContent)(() => ({
  backgroundColor: "#fff",
  fontWeight: 700,
}));
